import {SoundUserPreferences} from "./user-sound-preferences";
import {ISoundUserPreferences} from "./user-sound-preferences.interface";

export class UserPreferences {
    sound: ISoundUserPreferences = new SoundUserPreferences();
}
